export var REGION_MODAL_TEXTS = {
  title: 'выберите ваше местоположение',
  emptySearch: 'не смогли ничего найти по вашему запросу'
};